export default "__VITE_ASSET__Diw8L4CM__"